import React, { Suspense } from 'react';
import { Switch, Route } from "react-router-dom";

import ErrorPage from "src/shared_modules/veu-visitors-core/components/error/page";

import appCoreRoutes from "src/shared_modules/veu-visitors-core/components/app-routing";
import appPlazzRoutes from "src/shared_modules/veu-visitors-plazz/components/app-routing";

const AppRouting = (props) => {
    var appRoutes = [];
    if( props.enablePlazz )
        appRoutes.push(...appPlazzRoutes);

    appRoutes.push(...appCoreRoutes);

    return (<Suspense fallback={<div>Loading...</div>} >
                <Switch>
                    {
                        appRoutes.map(({
                            component: Component,
                            path,
                            exact,
                        }) => {
                            return(
                                <Route key={path}
                                    path={path}
                                    exact={exact}
                                    render={(compProps) =>  <Component {...compProps} />  }
                                />
                            );
                        })
                    }
                    <Route path='/:event/:fail'>
                        <ErrorPage status="404" msg="Not Found" />
                    </Route>
                </Switch>
            </Suspense>);
}

/*
* ---------------------------------------------------------------------
* Export the redux container
* ---------------------------------------------------------------------
*/
export default AppRouting;
